export const previewActionItems = {
  "1774498029778-86781-LNymX-challenge-actionitem": {
    "fileType": null,
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "elementDocNum": null,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "ts_submitted": 1774498029778,
    "event": "Challenge Submitted",
    "id": "1774498029778-86781-LNymX-challenge-actionitem",
    "approval_ts": 1774498048484,
    "ts": 1774498047500,
    "fileName": null,
    "approval_name": "Adam @ Gamably",
    "activityRecordId": "1774498048484-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge",
    "inputText": "I shared my video with you in Google Classroom",
    "comments": "Excellent video!",
    "status": "approved",
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "file": null,
    "quantity": null,
    "upload": false,
    "type": "challenge",
    "path": "7_6s9wx7_11r1mi29g"
  },
  "1774501243641-86781-LNymX-challenge-actionitem": {
    "status": "approved",
    "comments": "Well done!",
    "file": null,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "inputText": "I have uploaded my Character Map.",
    "activityRecordId": "1774501436178-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge",
    "path": "ctwn2fw842dzk6e7dk",
    "type": "challenge",
    "upload": false,
    "quantity": null,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "ts_submitted": 1774501243641,
    "elementDocNum": null,
    "approval_ts": 1774501436178,
    "event": "Challenge Submitted",
    "id": "1774501243641-86781-LNymX-challenge-actionitem",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772572118651-86781-LNymX-challenge",
    "approval_name": "Adam @ Gamably",
    "fileName": null,
    "ts": 1774501435041
  },
  "1774535538361-86781-LNymX-challenge-actionitem": {
    "ts": 1774572336346,
    "approval_name": "Adam @ Gamably",
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "approval_ts": 1774572338000,
    "event": "Challenge Submitted",
    "id": "1774535538361-86781-LNymX-challenge-actionitem",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "ts_submitted": 1774535538361,
    "elementDocNum": null,
    "quantity": null,
    "type": "challenge",
    "path": "fjuuhofkhefkouo7xb",
    "inputText": "I read \"The Last Question\" by Isaac Asimov. The story follows a supercomputer named Multivac over trillions of years as humans repeatedly ask if the universe's eventual death can be reversed. As humanity evolves and merges with the computer, the universe finally goes dark and cold. In the end, the computer figures out the answer and creates a brand-new universe with a single command.",
    "activityRecordId": "1774572338000-ZvZ0CMN6ywykvdvTHuOPvRKz-approvedChallenge",
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "status": "approved",
    "comments": "Great summary! I hope you enjoy the book!"
  },
  "1774536340963-86781-LNymX-challenge-actionitem": {
    "activityRecordId": "1774572403947-ZvZ0CMN6ywykvdvTHuOPvRKz-declinedChallenge",
    "inputText": "I uploaded my video.",
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "file": null,
    "comments": "Sorry, that didn't meet the requirements. Try again and upload your new video. Be sure to focus on emulating the way we think Romans would have sounded based on your reading.",
    "status": "declined",
    "quantity": null,
    "upload": false,
    "path": "-xp0vkrsxxb0dvv4ne",
    "type": "challenge",
    "elementId": "1772569770551-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "fileType": null,
    "event": "Challenge Submitted",
    "id": "1774536340963-86781-LNymX-challenge-actionitem",
    "approval_ts": 1774572403947,
    "elementDocNum": null,
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "ts_submitted": 1774536340963,
    "ts": 1774572402360,
    "fileName": null,
    "approval_name": "Adam @ Gamably"
  },
  "1774571645810-86781-LNymX-challenge-actionitem": {
    "upload": false,
    "type": "challenge",
    "path": "c_chjwqqonm55wh2-m",
    "quantity": null,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "file": null,
    "comments": "Great prophecy! That's a fantastic novel.",
    "status": "approved",
    "activityRecordId": "1774572421960-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge",
    "inputText": "Of Mice and Men by John Steinbeck\nMy prophecy is that George is going to end up alone and really sad because he keeps having to fix all the problems Lennie makes. Since he already told Lennie to hide in the brush if things go bad, I think something terrible is going to happen at the new ranch soon. He will probably have to give up on the dream of the farm with the rabbits because they never stay in one place long enough to save money.",
    "approval_name": "Adam @ Gamably",
    "ts": 1774572420497,
    "fileName": null,
    "event": "Challenge Submitted",
    "id": "1774571645810-86781-LNymX-challenge-actionitem",
    "approval_ts": 1774572421960,
    "elementDocNum": null,
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "ts_submitted": 1774571645810,
    "elementId": "1772569834612-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "fileType": null
  },
  "1774571686524-86781-LNymX-challenge-actionitem": {
    "gameId": "1772165586781-LNymXRI-game",
    "elementId": "1772569770551-86781-LNymX-challenge",
    "fileType": null,
    "approval_ts": 1774572434610,
    "id": "1774571686524-86781-LNymX-challenge-actionitem",
    "event": "Challenge Submitted",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "ts_submitted": 1774571686524,
    "elementDocNum": null,
    "fileName": null,
    "ts": 1774572433193,
    "approval_name": "Adam @ Gamably",
    "inputText": "I uploaded my video",
    "activityRecordId": "1774572434610-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge",
    "file": null,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "status": "approved",
    "comments": "Excellent!",
    "quantity": null,
    "type": "challenge",
    "path": "-p7vm42mwh-qdrour1",
    "upload": false
  },
  "1774623815987-86781-LNymX-item-actionitem": {
    "elementId": "1772230537871-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1774623815987-86781-LNymX-item-actionitem",
    "event": "Item Used",
    "elementDocNum": null,
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "ts_submitted": 1774623815987,
    "ts": 1774623815987,
    "inputText": "I would like to use it during lunch today.",
    "status": "pending",
    "quantity": 1,
    "path": "a9y-y7l0nz1q2h9arn",
    "type": "item"
  },
  "1774818340234-86781-LNymX-challenge-actionitem": {
    "ts": 1774818340234,
    "fileName": null,
    "elementId": "1772569886040-86781-LNymX-challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "fileType": null,
    "event": "Challenge Submitted",
    "id": "1774818340234-86781-LNymX-challenge-actionitem",
    "elementDocNum": null,
    "ts_submitted": 1774818340234,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "upload": false,
    "type": "challenge",
    "path": "0eudpi_et8pwey021h",
    "inputText": "I read \"The Mystery of the Ghost Ship Mary Celeste\" (Historical Archive Article)\n\nBasically, ,in 1872, a ship was found floating in the Atlantic with its entire crew missing but the cargo and supplies completely untouched. Numerous theories have been proposed, ranging from pirate attacks to underwater earthquakes, but no one has ever found a trace of the sailors. The mystery remains one of the most famous \"cold cases\" in maritime history. This connects to our Intro to Rhetoric unit because the article uses \"Logos\" to debunk the crazier theories (like sea monsters) by showing that there was no physical damage to the ship’s hull.",
    "file": null,
    "status": "pending"
  }
}